export default function contentHandle(handleNames, content, picList){
    if(!handleNames){
        console.error("参数内容处理器名称值不存在, handleNames:", handleNames);
        return content;
    }
    if(!(handleNames instanceof Array)){
        console.error("参数内容处理器名称不是一个数组, handleNames:", handleNames);
        return content;
    }
    if(handleNames.length <= 0){
        console.error("参数内容处理器名称不是一个数组为空, handleNames:", handleNames);
        return content;
    }
    for(let i = 0 ; i < handleNames.length ; i++){
        let handleName = handleNames[i];
        let handleNameMethod = require(`./${handleName}.js`).default;
        content = handleNameMethod(content, picList);
    }
    return content;
}